export const baseUrl = import.meta.env.VITE_BACKEND_URL ?? "";
